import { render, staticRenderFns } from "./TenderRelatedSources.vue?vue&type=template&id=4d87986c"
import script from "./TenderRelatedSources.vue?vue&type=script&lang=js"
export * from "./TenderRelatedSources.vue?vue&type=script&lang=js"
import style0 from "./TenderRelatedSources.vue?vue&type=style&index=0&id=4d87986c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports